import { PRECIOS, formatCLP } from "./precios";
import { ESTUDIO } from "./estudio";

/**
 * Preguntas de la home.
 *
 * Son las transversales: las de cada servicio viven en segmentos.js. Están
 * aquí, en datos y no en la página, porque el mismo array alimenta el bloque
 * visible y el FAQPage de datos estructurados. Si se escribieran en el JSX,
 * el schema y la página podrían decir cosas distintas — y eso es exactamente
 * lo que Google penaliza.
 *
 * La primera pregunta es deliberada: *"sesión de fotos precio chile"* es la
 * sugerencia de país número uno de Google. La respuesta lleva una cifra en la
 * primera frase, porque una respuesta sin número no gana esa consulta ni se
 * cita en un resumen de IA.
 *
 * Ningún precio se escribe a mano: todo sale de precios.js.
 */

export const FAQS_HOME = [
  {
    q: "¿Cuánto cuesta una sesión de fotos en Chile?",
    a: `En Omega Digital, los eventos — revelación, boda, graduación o fotografía gastronómica — parten en ${formatCLP(
      PRECIOS.horaYMedia
    )} por hora y media y 20 fotos editadas, solo fotografía. Dos horas y 30 fotos son ${formatCLP(
      PRECIOS.dosHoras
    )}, o ${formatCLP(PRECIOS.bodaDosHoras)} en una boda. El completo, de cuatro horas y 80 fotos, ${formatCLP(
      PRECIOS.cuatroHoras
    )}. La sesión en estudio tiene precio cerrado: ${formatCLP(
      PRECIOS.estudio
    )} por una hora y 10 fotos editadas. Para emprendedores, marca personal y partidos, ${formatCLP(
      PRECIOS.diezFotos
    )} por una hora y cada 10 fotos.`,
  },
  {
    q: "¿Qué fotografían?",
    a: "Eventos: revelaciones de sexo, embarazo, baby showers, bodas, graduaciones y fotografía gastronómica. Además, emprendedores y marca personal, partidos y equipos deportivos, y sesiones en estudio: retratos, embarazo y familia.",
  },
  {
    q: "¿Los precios de la web son los de verdad?",
    a: "Sí. Es el valor que se cobra y el que queda en la factura. Lo único que cambia el total es el pack que eliges.",
  },
  {
    q: "¿Emiten factura?",
    a: ESTUDIO.emiteFactura
      ? "Sí. Omega Digital emite factura y el valor publicado es final."
      : "Se emite boleta.",
  },
  {
    q: "¿Dónde se fotografía?",
    a: "El evento, donde ocurra: llevamos la iluminación. La sesión, en el estudio en Santiago; la dirección se envía por WhatsApp al confirmar la fecha.",
  },
  {
    q: "¿En cuánto tiempo se entrega?",
    a: "Los eventos en 72 horas y las sesiones en estudio en 5 días hábiles. Se entrega en alta resolución para imprimir y en versión liviana para web y redes.",
  },
  {
    q: "¿Puedo usar las fotos en publicidad y en redes?",
    a: "Sí. El uso comercial va incluido y sin vencimiento: web, redes, impresos y campañas pagadas. No se cobra por licencia ni por renovarla. La única excepción son las fotos donde aparecen otras personas reconocibles, que necesitan la autorización de esa persona.",
  },
  {
    q: "¿Publican mis fotos en su portafolio?",
    a: "Solo con tu autorización por escrito, y se pide en la misma sesión para que quede claro antes y no después. Si no la das, las fotos son tuyas y no aparecen en ninguna parte: ni en la web, ni en redes, ni en presentaciones. Nunca se venden ni se ceden a terceros ni se suben a bancos de imágenes, aunque hayas autorizado el portafolio. Y si cambias de opinión, las bajamos de nuestros canales en 10 días hábiles.",
  },
  {
    q: `¿Cubren eventos fuera de ${ESTUDIO.ciudad}?`,
    a: `${ESTUDIO.cobertura[0]} sin recargo. Fuera de la región se cotiza el traslado aparte y se dice antes, no en la factura.`,
  },
];
